// extracted by mini-css-extract-plugin
export const facebook = "social-button-module--facebook--FPu2O";
export const instagram = "social-button-module--instagram--2WaMt";
export const linkedin = "social-button-module--linkedin--2HfrM";
export const reddit = "social-button-module--reddit--3ThSl";
export const twitter = "social-button-module--twitter--hoP2M";
export const button = "social-button-module--button--sZ9Js";